<template>
  <div>
    <select :multiple="multiple" :name="name" class="ocultar">
      <option
        v-for="option in getValue"
        :key="option"
        :value="option"
        selected
      >
        {{ option }}
      </option>
    </select>
    <selector-usuario
      v-bind="$attrs"
      v-model="valueSelector"
      :multiple="multiple"
    />
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, default: undefined },
    multiple: { type: Boolean, default: false },
    modelValue: { type: [String, Array], default: undefined },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      valueSelector: this.modelValue,
    };
  },
  computed: {
    getValue() {
      let res = this.valueSelector || [];
      if (this.valueSelector && !this.multiple && !Array.isArray(this.valueSelector)) {
        res = [this.valueSelector];
      }
      return res;
    },
  },
  watch: {
    valueSelector(value) {
      this.$emit('update:modelValue', value);
    },
  },
};
</script>
<style lang="scss" scoped>
  .ocultar {
    display: none;
  }
</style>
